import type {
  MemberHeaderVisibleMenuItems,
  MemberOverlayName
} from '@library/types/members';
import { Button } from '@library/components/buttons';
import ChangeLogIcon from '@library/assets/images/icons/change-log-icon.svg';
import CreateNoteIcon from '@library/assets/images/icons/create-note-icon.svg';
import { MemberAdditionalActionsKebabMenu } from '@library/components/menus/kebabMenu/MemberAdditionalActionsKebabMenu';
import { selectMemberActionsAccessPermissions } from '@bo-selectors/members/memberActionPermissions';
import { selectMemberTabsAccessPermisions } from '@bo-selectors/members/memberTabAccessPermisions';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

export interface MemberHeaderActionButtonsProps {
  isDeactivated: boolean;
  onShowModal: (value: MemberOverlayName) => void;
  visibleMenuItems: MemberHeaderVisibleMenuItems;
}

export const MemberHeaderActionButtons = ({
  isDeactivated,
  onShowModal,
  visibleMenuItems
}: MemberHeaderActionButtonsProps) => {
  const actionBtnClasses =
    'flex items-center justify-center size-12 hover:bg-soFresh-130 rounded-md';

  const { hasViewMemberNotesAccess } = useSelector(
    selectMemberTabsAccessPermisions
  );

  const { hasAccessMemberActionsMenu, hasAccessMemberChangeLog } = useSelector(
    selectMemberActionsAccessPermissions
  );

  const handleShowModal = useCallback(
    (modalName: MemberOverlayName) => {
      onShowModal(modalName);
    },
    [onShowModal]
  );

  // Return null if there are no actions to show
  if (
    !hasAccessMemberActionsMenu &&
    !hasAccessMemberChangeLog &&
    !hasViewMemberNotesAccess
  ) {
    return null;
  }

  return (
    <div className="flex items-center">
      {hasViewMemberNotesAccess && (
        <Button
          onClick={() => handleShowModal('CREATE_NOTE')}
          className={actionBtnClasses}
        >
          <img src={CreateNoteIcon} alt="Create Note" />
        </Button>
      )}
      {hasAccessMemberChangeLog && (
        <Button
          onClick={() => handleShowModal('CHANGE_LOG')}
          className={actionBtnClasses}
        >
          <img src={ChangeLogIcon} alt="Change Log" />
        </Button>
      )}
      {hasAccessMemberActionsMenu && (
        <MemberAdditionalActionsKebabMenu
          isDeactivated={isDeactivated}
          onShowModal={onShowModal}
          visibleMenuItems={visibleMenuItems}
        />
      )}
    </div>
  );
};
